import slugify from "slugify"
import React from "react"
import ArticlePreview from "./ArticlePreview"
import { Spacer, HR } from "../atoms/Atoms"
import PropTypes from "prop-types"
import { H2 } from "@carrotfertility/carotene"
import { ContentfulConditionalGate } from "../../../lib/contentful/components/ContentfulConditionGate"

const LibrarySubCategory = ({ subCategory, categorySlug, displayTitle }) => {
  const { fields } = subCategory
  const subCategorySlug = slugify(fields.navTitle ? fields.navTitle : fields.title)

  return (
    <div id={subCategorySlug}>
      <ContentfulConditionalGate conditions={fields.conditions}>
        {displayTitle && (
          <>
            <HR color="pampas" width={2} />
            <Spacer height={0.75} />
            <H2 color="black60">{fields.title}</H2>
            <Spacer height={1.5} />
          </>
        )}
        <div className="flex flex-wrap justify-between nh35">
          {fields.articles.map((article) => (
            <ContentfulConditionalGate key={article.sys.id} conditions={article.fields.conditions}>
              <div key={article.sys.id} className="flex-grow-1 w-50 min-w250px mb3 pb2 ph35">
                <ArticlePreview article={article} categorySlug={categorySlug} />
              </div>
            </ContentfulConditionalGate>
          ))}
          {/* Because we're using flex-grow-1, if there are and of number of articles it will take up the whole row */}
          {fields.articles.length % 2 !== 0 && <div className="w-50" />}
        </div>
      </ContentfulConditionalGate>
    </div>
  )
}

LibrarySubCategory.propTypes = {
  subCategory: PropTypes.object.isRequired,
  categorySlug: PropTypes.string.isRequired,
  displayTitle: PropTypes.bool.isRequired
}

export default LibrarySubCategory
